import {
  Autocomplete,
  Box,
  CircularProgress,
  InputAdornment,
  Popover,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { KeyboardArrowUp, Search as SearchIcon } from '@mui/icons-material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { colorsEnums } from '../constants/enums';
import LocationMenuModal from './locationMenuModal';

export default function LocalitySearchDropdownInHome({
  options = [],
  location,
  setLocation,
  placeholder = 'Select',
  isLoading,
  handleInputChange,
  inputRef,
  searchInput,
  setSearchInput,
  handleClick,
  handleClose,
  open,
  anchorEl,
  id,
  errorMessage,
  fromHome = false,
}) {
  const truncateText = (text, maxLength) => {
    const trimmed = text?.trim();
    return trimmed?.length > maxLength
      ? `${trimmed?.substring(0, maxLength)}...`
      : trimmed;
  };
  return (
    <Box sx={{ width: '100%', display: 'flex', cursor: 'pointer' }}>
      <Typography
        sx={{
          width: fromHome ? '100%' : '100%',
          display: 'flex',
          alignItems: 'center',
          fontSize: '14px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          justifyContent: 'space-between',
        }}
        onClick={handleClick}
      >
        <>
          {location ? (
            <span style={{ marginRight: '16px' }}>
              {truncateText(location?.split(',')[0], 10)}
            </span>
          ) : (
            <span style={{ color: '#aaa', fontSize: '14px' }}>
              {placeholder}
            </span>
          )}
        </>

        <span
          style={{
            display: 'flex',
            alignContent: 'center',
            marginRight: '8px',
          }}
        >
          {anchorEl ? (
            <KeyboardArrowUp
              sx={{
                color: 'rgba(0, 0, 0, 0.54)',
              }}
            />
          ) : (
            <KeyboardArrowDownIcon
              sx={{
                color: 'rgba(0, 0, 0, 0.54)',
              }}
            />
          )}
        </span>
      </Typography>

      {errorMessage && (
        <Typography
          style={{
            color: colorsEnums.error,
            fontSize: '12px',
            mt: '5px',
          }}
        >
          {errorMessage}
        </Typography>
      )}
      <LocationMenuModal
        id={id}
        open={open}
        handleClose={handleClose}
        anchorEl={anchorEl}
        options={options}
        setLocation={setLocation}
        isLoading={isLoading}
        handleInputChange={handleInputChange}
        inputRef={inputRef}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
      />
    </Box>
  );
}
